import { initBrowser } from '@bloomstack/greenhouse/browserShim';
initBrowser();

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import { getConfig } from './lib/config';
import { initHighlightWorker } from './hooks/useShikiHighlighter';
import 'rc-dock/dist/rc-dock.css';
import './styles/globals.css';
// DiffView styling — kept at the global entry (not in the component) so
// node-based component tests can import DiffView without hitting .css
// side-effect imports (tsx cannot load them).
import 'react-diff-view/style/index.css';
import './components/ui/diffView/darkTheme.css';

/**
 * Register service worker for PWA installability
 */
function registerServiceWorker() {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.register('/sw.js').catch((err) => {
      console.warn('[Portal] Service worker registration failed:', err);
    });
  }
}

/**
 * Bootstrap the application.
 * 
 * Loads runtime configuration before rendering to ensure
 * Keycloak and other services have the correct settings.
 */
async function bootstrap() {
  // Register service worker for PWA
  registerServiceWorker();

  // Start the syntax highlight worker in the background during idle time
  if ('requestIdleCallback' in window) {
    requestIdleCallback(() => initHighlightWorker());
  } else {
    setTimeout(initHighlightWorker, 0);
  }

  // Load config first - this is likely already fetched due to preload
  const config = await getConfig();

  // Render the app
  createRoot(document.getElementById('root')!).render(
    <StrictMode>
      <App />
    </StrictMode>
  );
}

bootstrap();
